module.exports = __webpack_public_path__ + "img/mansion.84e46abf.jpg";